module.exports = {"510181001":"奎光塔街道","510181002":"幸福街道","510181003":"永丰街道","510181004":"灌口街道","510181005":"银杏街道","510181102":"蒲阳镇","510181103":"聚源镇","510181104":"崇义镇","510181105":"天马镇","510181106":"石羊镇","510181107":"柳街镇","510181108":"玉堂镇","510181109":"中兴镇","510181110":"青城山镇","510181111":"龙池镇","510181112":"胥家镇","510181113":"安龙镇","510181114":"大观镇","510181202":"向峨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510181.json
// module id = 2270
// module chunks = 0